<template>
  <div :style="contentStyle">
    <slot v-for="slot in slots" :name="slot">
      <div
        :key="slot"
        :class="['title', line ? `line line-${lineDirection}` : '']"
        :style="{ 'justify-content': align }"
      >
        <slot name="label">
          <span :style="labelStyle" :class="{ 'bar': bar }">{{ label }}</span>
        </slot>

        <slot name="extra">
          <span v-if="extraShow" :style="extraStyle" class="extra" v-on="events">
            <i v-if="icon" :class="icon"></i>
            <svg-icon v-if="svgIcon" :icon-class="svgIcon"></svg-icon>
            <span v-if="text" :style="textStyle">{{ text }}</span>
          </span>
        </slot>
      </div>
    </slot>
  </div>
</template>

<script>
import { slotMixins } from "../mixins/slotMixins";
export default {
  name: "RcAddonTitle",
  mixins: [slotMixins],
  props: {
    // 样式
    contentStyle: {
      type: Object,
      default: () => {}
    },
    extraShow: {
      type: Boolean,
      default: false
    },
    events: {
      type: Object,
      default: () => {}
    },
    // 文字
    label: String,
    // 编辑文字
    text: String,
    // 文字样式
    labelStyle: {
      type: Object,
      default: () => {}
    },
    textStyle: {
      type: Object,
      default: () => {}
    },
    extraStyle: {
      type: Object,
      default: () => {}
    },
    // 直线
    line: Boolean,
    // 线指向
    lineDirection: {
      type: String,
      default: () => "bottom"
    },
    // 前缀bar
    bar: Boolean,
    // 插槽
    slots: {
      type: Array,
      default: () => ["default"]
    },
    icon: String,
    svgIcon: String,
    align: {
      type: String,
      default: "space-between"
    }
  }
};
</script>

<style lang="scss" scoped>
  .title {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .line-left {
    border-left: 1px solid;
  }

  .line-right {
    border-right: 1px solid;
  }

  .line-top {
    border-top: 1px solid;
  }

  .line-bottom {
    border-bottom: 1px solid;
  }

  .line {
    padding-bottom: 16px;
    border-color: #f3f3f5;
  }

  .bar {
    &::before {
      display: inline-block;
      width: 3px;
      height: 18px;
      margin-right: 5px;
      vertical-align: text-bottom;
      background: #00B259;
      content: "";
      opacity: 1;
    }
  }

  .extra {
    cursor: pointer;
  }
</style>
